import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../Components/Common/const'
import FeaturedVehicles from '../Components/Home/FeaturedVehicles'
import ContactForm from '../Components/Common/ContactForm';
import HomeVideo from '../Components/Home/HomeVideo';
import HomeBanner from '../Components/Home/HomeBanner';
import HomeServices from '../Components/Home/HomeServices';
import HomeAbout from '../Components/Home/HomeAbout';
import HomeReviews from '../Components/Home/HomeReviews';
import HomeContact from '../Components/Home/HomeContact';
import TopAppraisal from '../Components/Home/TopAppraisal';
import { VehicleContext } from '../Components/Context/VehicleContext';
import SeoMeta from '../Components/Common/SeoMeta';
import { Helmet } from 'react-helmet';

const Home = () => {
  // const googleReviewLink = "https://www.google.com/search?client=firefox-b-d&sca_esv=4c75ca2344971d57&sxsrf=AHTn8zrXLSulgua0mTGex92jwZEQfrnmAw:1744311051147&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzdH8B6cLDEUVopuZzUUDA0BqM7_hZWYqBAOJKfCXUcv35GvEWOaOpM2RdG4GXaLOQIbU3mCXbAWnvRGl80eDM1YgqzYY&q=Mark+Motors+Reviews&sa=X&ved=2ahUKEwijktOEkc6MAxW8UWcHHczWGe4Q0bkNegQIMxAE&biw=1536&bih=731&dpr=1.25&sei=JxP4Z6W0AayK4-EP6rOBCQ";

  const videoRef = useRef(null);
  const handleVideoClick = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause(); // optional: toggle
      }
    }
  };
  // Video Fixed on Screen
  const videoSectionRef = useRef(null);
  const [videoInView, setVideoInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVideoInView(entry.isIntersecting); // true when in view, false when out
      },
      {
        threshold: 0.3, // change threshold as needed
      }
    );

    if (videoSectionRef.current) {
      observer.observe(videoSectionRef.current);
    }

    return () => {
      if (videoSectionRef.current) {
        observer.unobserve(videoSectionRef.current);
      }
    };
  }, []);
  
  const {getVehicleData,numberFormatter,priceFormatter,filteredVehicleData} = useContext(VehicleContext);
  useEffect(() => {
      getVehicleData();
  }, []);
  return (
    <>
      <Helmet>
          <title>Used Mercedes-Benz Dealer | Pompano Beach, FL</title>
          <meta name="description" content="Shop low-mileage used Mercedes-Benz cars in Pompano Beach. Family-owned, shipping worldwide since 1987." />
          <meta name="keywords" content="" />
          <meta property="og:title" content="Used Mercedes-Benz Dealer | Pompano Beach, FL" />
          <meta property="og:description" content="Shop low-mileage used Mercedes-Benz cars in Pompano Beach. Family-owned, shipping worldwide since 1987." />
      </Helmet>
      <HomeBanner />
      <HomeServices />
      <HomeAbout />
      <TopAppraisal />
      {filteredVehicleData && 
        <FeaturedVehicles 
          featuredVehicles={filteredVehicleData.filter((item) => item.inventory_manage.featured)} 
          numberFormatter={numberFormatter}
          priceFormatter={priceFormatter}
        />
      }
      <section ref={videoSectionRef}>
        <HomeVideo inView={videoInView} />
      </section>
      <HomeReviews />
      <HomeContact />
    </>
  )
}

export default Home